import * as React from 'react';

const ScienceAndTechSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.75 3a.375.375 0 00-.375.375v5.439a6.376 6.376 0 105.25 0V3.375A.375.375 0 0014.25 3h-4.5zm1.125 3.375h-.75v2.686c0 .153-.092.29-.234.348A5.628 5.628 0 008.176 10.5h1.199a.375.375 0 010 .75H7.5c-.34.452-.613.957-.805 1.5h10.61a5.642 5.642 0 00-3.195-3.341.375.375 0 01-.235-.348V6.375h-.75a.375.375 0 010-.75h.75V3.75h-3.75v1.875h.75a.375.375 0 010 .75zM6.488 13.5a5.65 5.65 0 00-.1 1.5h2.987a.375.375 0 010 .75H6.488c.107.531.29 1.035.536 1.5h2.351a.375.375 0 010 .75H7.5a5.625 5.625 0 0010.013-4.5H6.487zm7.012 2.25a.375.375 0 11.75 0 .375.375 0 01-.75 0zm.375-1.125a1.125 1.125 0 100 2.25 1.125 1.125 0 000-2.25z"
            fill="#585163"
        />
    </svg>
);

ScienceAndTechSvg.displayName = 'ScienceAndTechSvg';
export default ScienceAndTechSvg;
